

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class BehaviorDropdown extends Vue {
    displayText = "";
    @Prop({ default: "Choose.." }) text!: string;
    @Prop({ type: Array, default: () => [] }) behaviorTypes!: Array<{ id: string, name: string }>;
    @Prop() localProperties: any;
    @Prop({ default: false }) textOnly!: boolean;
    @Prop() adjustOnly!: string;

    get behaviorClass() {
        return {
            items4: this.behaviorTypes.length === 4,
            items3: this.behaviorTypes.length === 3
        };
    }

    mounted() {
        this.displayText = this.text;
        this.setDefaultValue();
    }

    @Watch("localProperties")
    onLocalPropertiesChanged() {
        this.setDefaultValue();
    }

    setBehavior(item: { id: string, name: string }) {
        this.localProperties.behavior = item.id;
        this.displayText = item.name;
    }

    setDefaultValue() {
        // If a default value has been set by the parent, we get the name based off the ID and set the text to said name.
        if (this.localProperties.behavior !== undefined && this.localProperties.behavior !== "") {
            const selectedBehavior = this.behaviorTypes.filter((e: any) => e.id === this.localProperties.behavior)[0];
            if (selectedBehavior) this.displayText = selectedBehavior.name;
        }
    }
}
